module.exports = __webpack_public_path__ + "img/logo.17d8ead1.png";